// extracted by mini-css-extract-plugin
export var cardSelected = "_fy-2";
export var image = "_fy-1";
export var table = "_fy-0";